// utils/api/ClassApi.js

import { apiCall } from './ApiUtils';

export const classApi = {
  // Class management
  getClasses: () => apiCall('/classes'),
  getUserClasses: (username) => apiCall(`/user/${encodeURIComponent(username)}/classes`),
  
  createClass: (classData) => apiCall('/classes', {
    method: 'POST',
    body: JSON.stringify(classData)
  }),
  
  updateClass: (classId, classData) => apiCall(`/classes/${classId}`, {
    method: 'PUT',
    body: JSON.stringify(classData)
  }),
  
  deleteClass: (classId) => apiCall(`/classes/${classId}`, {
    method: 'DELETE'
  }),
  
  // Class enrollment management
  getClassEnrollments: (classId) => apiCall(`/classes/${classId}/enrollments`),
  
  enrollUsers: (classId, usernames) => apiCall(`/classes/${classId}/enroll`, {
    method: 'POST',
    body: JSON.stringify({ usernames })
  }),
  
  unenrollUser: (classId, username) => apiCall(`/classes/${classId}/unenroll`, {
    method: 'POST',
    body: JSON.stringify({ username })
  }),

  // Canvas Integration
  saveCanvasCredentials: (canvasUrl, accessToken) => apiCall('/canvas/credentials', {
    method: 'POST',
    body: JSON.stringify({
      canvas_url: canvasUrl,
      access_token: accessToken
    })
  }),

  getCanvasCredentials: () => apiCall('/canvas/credentials'),

  getCanvasCourses: () => apiCall('/canvas/courses'),

  linkCanvasCourse: (classId, canvasCourseId, canvasCourseName) => apiCall('/canvas/link-course', {
    method: 'POST',
    body: JSON.stringify({
      class_id: classId,
      canvas_course_id: canvasCourseId,
      canvas_course_name: canvasCourseName
    })
  }),

  syncGradesToCanvas: (classId, assignmentId) => apiCall('/canvas/sync-grades', {
    method: 'POST',
    body: JSON.stringify({
      class_id: classId,
      assignment_id: assignmentId
    })
  }),

  previewCanvasStudents: (classId) =>
    apiCall(`/canvas/preview-students?class_id=${encodeURIComponent(classId)}`),

  syncStudentsFromCanvas: (classId) => apiCall('/canvas/sync-students', {
    method: 'POST',
    body: JSON.stringify({ class_id: classId })
  }),
};